import TestPrintsFormInputs from './TestPrintsFormInputs'

export default TestPrintsFormInputs
